import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import AddressbookTree from './AddressbookTree';
import AddressbookPegawai from './AddressbookPegawai';
import AddressbookPersonal from './AddressbookPersonal';
import AddressbookKlasifikasi from './AddressbookKlasifikasiArsip';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { useSelector } from 'react-redux';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material';

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  () => ({
    '&.Mui-selected': {
      fontWeight: 'bold',
      color: '#800000',
    },
    '&.Mui-focusVisible': {
      backgroundColor: 'rgba(100, 95, 228, 0.32)',
    },
  }),
);

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    height: 3,
    backgroundColor: '#800000',
  },
});


function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
      style={{ height: 'calc( 100% - 48px )', overflowY: 'auto' }}
    >
      {value === index && (
        <Box sx={{ p: 0, width: 'max-content', minWidth: '100%' }}>
          {children}
        </Box>
      )}
    </div>
  );
}

const SelectDivision = ({ divId, handleChangeDiv,hideDivisi }) => {
  const tmpData = useSelector(({ divisi }) => {
    return divisi.detail;
  });

  if (hideDivisi){
    return "";
  }
  return (
    <div>
      {tmpData && (
        <FormControl
          sx={{
            m: 1,
            mt: 2,
            width: '250px',
            '& label.Mui-focused': {
              color: '#800000',
            },
            '& .MuiOutlinedInput-root': {
              '&:hover fieldset': {
                borderColor: grey[500],
              },
              '&.Mui-focused fieldset': {
                borderColor: '#800000',
                color: '#800000'
              },
            },
          }}
          size='small'>
          <InputLabel id='select-division'>Berdasarkan</InputLabel>
          <Select
            labelId='select-division'
            id='id-division'
            value={divId ? divId : tmpData[0].id}
            onChange={handleChangeDiv}
            autoWidth
            sx={{
              textAlign: 'start'
            }}
            label='Berdasarkan'
          >
            {tmpData &&
              tmpData.map((item) => {
                return (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      )}
    </div>
  );
};

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AddresbookTabs({
  tabs,
  multiselect,
  setPayloadOnHide,
  setPilihan,
  pilihan,
  searchText,
  isTransform,
  removeSearch,
  setPersonal,
  hideDivisi,
  defaultDivision,
  useCRSFE,
  closed,
  eselon1,
  eselon2
}) {
  const index = tabs.jabatan ? 0 : tabs.pegawai ? 1 : tabs.personal ? 2 : 3;
  const [value, setValue] = useState(index);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    removeSearch('');
  };

  const tmpData = useSelector(({ divisi }) => {
    return divisi.detail;
  });

  // Division State
  const [divId, setDivId] = useState(null);
  useEffect(()=>{
    if (tmpData[0]){
      setDivId(defaultDivision ? defaultDivision : tmpData[0].id);
    }
  },[tmpData]);
  const handleChangeDiv = (event) => {
    setDivId(event.target.value);
  };

  return (
    <>
    {
      divId && 
      <Box
        sx={{
          height: '100%',
        }}
      >
        <Box
          sx={{
            borderBottom: 1,
            borderColor: 'divider',
            display: 'flex',
            background: '#d3d3d366',
          }}
        >
          <StyledTabs
            value={value}
            onChange={handleChange}
            aria-label='basic tabs example'
          >
            {tabs.jabatan && (
              <StyledTab label='Jabatan' value={0} {...a11yProps(0)} />
            )}
            {tabs.pegawai && (
              <StyledTab label='Pegawai' value={1} {...a11yProps(1)} />
            )}
            {tabs.personal && (
              <StyledTab label='Personal' value={2} {...a11yProps(2)} />
            )}
            {tabs.klasifikasi && (
              <StyledTab label='Klasifikasi Arsip' value={3} {...a11yProps(3)} />
            )}
            {tabs.showLpmukp && (
              <StyledTab label='LPMUKP' value={4} {...a11yProps(4)} />
            )}
          </StyledTabs>
          {value == 0 && (
            <SelectDivision handleChangeDiv={handleChangeDiv} divId={divId} hideDivisi={hideDivisi} />
          )}
        </Box>
        <TabPanel value={value} index={0}>
          <AddressbookTree
            divId={divId}
            multiselect={multiselect}
            setPayloadOnHide={setPayloadOnHide}
            setPilihan={setPilihan}
            pilihan={pilihan}
            searchText={searchText}
            setPersonal={setPersonal}
            useCRSFE={useCRSFE}
            closed={closed}
            hideSubDivLpmukp={false}
            eselon1={eselon1}
            eselon2={eselon2}
          />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddressbookPegawai
            multiselect={multiselect}
            setPayloadOnHide={setPayloadOnHide}
            setPilihan={setPilihan}
            pilihan={pilihan}
            searchText={searchText}
            setPersonal={setPersonal}
            isTransform={isTransform}
            useCRSFE={useCRSFE}
            closed={closed}
          />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AddressbookPersonal
            multiselect={multiselect}
            setPayloadOnHide={setPayloadOnHide}
            setPilihan={setPilihan}
            pilihan={pilihan}
            searchText={searchText}
          />
        </TabPanel>
        <TabPanel value={value} index={3}>
          <AddressbookKlasifikasi
            multiselect={multiselect}
            setPayloadOnHide={setPayloadOnHide}
            setPilihan={setPilihan}
            searchText={searchText}
            useCRSFE={useCRSFE}
          />
        </TabPanel>
        <TabPanel value={value} index={4}>
          <AddressbookTree
            divId={11}
            multiselect={multiselect}
            setPayloadOnHide={setPayloadOnHide}
            setPilihan={setPilihan}
            pilihan={pilihan}
            searchText={searchText}
            setPersonal={setPersonal}
            useCRSFE={useCRSFE}
            closed={closed}
            hideSubDivLpmukp={true}
          />
        </TabPanel>
      </Box>
    }
    </>
  );
}

SelectDivision.propTypes = {
  divId: PropTypes.any,
  handleChangeDiv: PropTypes.func,
  hideDivisi:PropTypes.any,
  defaultDivision:PropTypes.any
};

AddresbookTabs.propTypes = {
  tabs: PropTypes.object,
  multiselect: PropTypes.bool,
  setPayloadOnHide: PropTypes.func,
  setPilihan: PropTypes.func,
  pilihan: PropTypes.array,
  isTransform:PropTypes.bool,
  divId: PropTypes.any,
  handleChangeDiv: PropTypes.func,
  searchText: PropTypes.any,
  removeSearch: PropTypes.func,
  setPersonal: PropTypes.func,
  hideDivisi:PropTypes.any,
  defaultDivision:PropTypes.any,
  useCRSFE:PropTypes.any,
  closed:PropTypes.any,
  eselon1:PropTypes.any,
  eselon2:PropTypes.any,
};
